/**
 * The agent Worker's origin — a build input, like `API_URL` (`data/api.ts`).
 *
 * A THIRD host, never derived from the API's (`@repo/client/chat`
 * `ai-base-url.ts`, `D09`): the agent Worker declares Durable Objects and
 * gets no per-branch preview URL, so the two are deployed apart.
 *
 * `VITE_AI_URL` is read here because `vite-env.d.ts` is not this feature's
 * file; Vite's own `ImportMetaEnv` types every `VITE_*` key as `any`. The
 * fallback is the VPS's local agent Worker (`mypocketgym-ai`, `:8788`), the
 * same way `data/api.ts` falls back to `:8787`.
 */
const DEFAULT_AI_URL = "http://100.84.151.119:8788";
const TRAILING_SLASHES = /\/+$/;

function configured(): string | undefined {
  const value: unknown = import.meta.env.VITE_AI_URL;
  return typeof value === "string" && value !== "" ? value : undefined;
}

export const AI_BASE_URL: string = (configured() ?? DEFAULT_AI_URL).replace(
  TRAILING_SLASHES,
  ""
);
